import { Link } from 'react-router-dom';

const TrinidadTobagoFooter = () => {
  return (
    <div className="w-full text-center py-3 border-t border-red-200 bg-gradient-to-r from-red-50 to-white">
      <div className="flex flex-col md:flex-row justify-between items-center gap-3 px-4">
        <Link 
          to="/" 
          className="text-red-600 hover:text-red-700 text-sm font-medium underline hover:no-underline transition-all duration-300"
        >
          Go to full website
        </Link>
        
        <div className="text-center">
          <p className="text-gray-600 text-sm mb-1">
            © 2025 NEXX TELECOM LLC. All Rights Reserved.
          </p>
          <p className="text-red-600 text-xs font-medium">
            🇹🇹 Serving Trinidad & Tobago with local currency options
          </p>
        </div>
        
        <div className="text-xs text-gray-500">
          TTD Exchange Rate: 1 USD = 6.75 TTD
        </div>
      </div>
    </div>
  );
};

export default TrinidadTobagoFooter;